import { Bar, Line } from "react-chartjs-2";
import React, { Component, useEffect, useState } from "react";

import ChartAnnotations from "chartjs-plugin-annotation";
import PropTypes from "prop-types";
import moment from "moment";

const ByPassChart = props => {
  // console.log(props.data)
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [data, setData] = useState({
    labels: [

    ],
    datasets: [
      {
        label: "Volume",
        backgroundColor: "#F1AF4E", //437AD5 น้ำเงินเดิม   F1AF4E สีส้มอ่อน
        borderColor: "#F1AF4E", //437AD5
        borderWidth: 3,
        pointBorderWidth: 2,
        hoverBorderWidth: 5,
        hoverBackgroundColor: "#F1AF4E", //437AD5 น้ำเงินเดิม
        hoverBorderColor: "#F1AF4E", //437AD5 น้ำเงินเดิม
        data: [],
        type: "line",
        showLine: true,
        pointStyle: "dot",
        // pointRadius: 1,
        fill: false,
        tension: 0,
        datalabels: {
          // anchor: "end",
          // align: "top",
          // offset: 1,
          // color: "#F898A4",
          // formatter: function (value, context) {
          //   if (value == 0) {
          //     return "";
          //   }
          //   return numberFormat(value, 0);
          // },
          font: {
            weight: 'bold',
            size: 14,
          }
        },
      },

    ],
  });

  const target = 5;

  const option = {
    maintainAspectRatio: false,
    title: {
      display: true,
      text: "Bypass Gas ( MMscfd )",
      fontColor: "#FFFFFF",
      fontSize: 14,
    },
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 15,
            labelString: "Date",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 15,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 15,
            labelString: "MMscfd",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            stepSize: 40,
            fontStyle: "bold",
            fontSize: 15,
            callback: function (label, index, labels) {
              var val = Math.abs(label);
              // if (val >= 1000) {
              //   if (label < 0) {
              //     val = val * -1;
              //   }
              //   val = numberFormat(val / 1000, 1) + " K";
              // } else {
              if (label < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
              // }

              return val;
            },
          },
        },
      ],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle: "bold",
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          return " " + numberFormat(tooltipItem.yLabel, 0);
        }
      },
    },
    legend: {
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
      },
    },

  };

  useEffect(() => {

    // console.log(props.data.filter(row => {
    //   return (
    //     moment(row.REPORT_DATE).format('YYYY-MM-DD') == '2022-07-04'
    //   );
    // }))

    // console.log(props.data.map(item => {
    //   // console.log(item.REPORT_DATE)
    //   return(
    //     moment(item.REPORT_DATE).format("YYYY-MM-DD")
    //   )
    // }))

    let dataSort = props.data.sort(function (a, b) {
      return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    });
    // .slice(Math.max(props.balancingGraphData.length - 15, 1));

    let dateList = [moment(props.date).locale("en").format("D MMM")];

    for (let index = 0; index < 14; index++) {
      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM")
      );
    }
    // console.log(dateList);
    let dataGraph = [];
    // console.log(dataSort.filter(row => {
    //   return (
    //     moment(row.REPORT_DATE).format('YYYY-MM-DD') == '2022-07-04'
    //   );
    // })
    // );
    dateList.map(item => {
      let data = dataSort.find(row => {
        // console.log(item, moment(props.date).locale("en").format("D MMM YYYY"));
        if (item == moment(props.date).locale("en").format("D MMM")) {
          // console.log(item, moment(props.date).locale("en").format("D MMM YYYY"));
          // console.log(props.summaryReportPid, row.SUMMARYREPORT_PID,moment(row.REPORT_DATE).locale("en").format("D MMM YYYY"),item);
          // if (moment(row.REPORT_DATE).locale("en").format("D MMM YYYY") == item &&
          //   props.summaryReportPid == row.SUMMARYREPORT_PID) {
          //   // console.log(row);
          // }
          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });
      dataGraph.push(data?.BYPASSGAS_VOLUME);
    });
    // console.log(dataSort,dataSort.map(row=>moment(row.REPORT_DATE).locale("en").format("D MMM YYYY")))
    setData(prev => ({
      ...prev,
      labels: dateList,
      datasets: [{ ...prev.datasets[0], data: dataGraph }],
    }));

    // console.log(dataGraph)
  }, [props.data, props.date]);
  return (
    <React.Fragment>
      <Line height={70} data={data} options={option} />
      {/* width={190} */}
    </React.Fragment>
  );
};
ByPassChart.propTypes = {
  data: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};
export default ByPassChart;
